import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["form", "button"];

    DELETE_CONFIRMED = false;

    connect()
    {
        this.buttonTarget.addEventListener("click", e=>
        {
            if(!this.DELETE_CONFIRMED)
            {
                e.preventDefault();
                let event = new CustomEvent("show-dialog", { detail: this.buttonTarget });
                window.dispatchEvent(event);
            }
            
        })

        this.buttonTarget.addEventListener("confirm-delete", e=>
        {
            this.DELETE_CONFIRMED = true;
            this.buttonTarget.click();
        })
    }

}